module.exports = __webpack_public_path__ + "img/Team-MichaelBuff.5a9ea813.png";